(ns minorodata.sql-console.events
  (:require [applied-science.js-interop :as js-interop]
            [minorodata.app.handlers :refer [reg-event-fx dispatch reg-event-db]]
            [minorodata.app.utils :as app.utils]
            [minorodata.sql-console.model :refer [->sql-metadata ->sql-editor]]
            [re-posh.core :as re-posh]
            [mold-http.core :refer [reg-event-http]]
            [oxbow.re-frame :as o]))


;; TODO: Figure out the best way of working with workers.
;;
;; It's just a lot of global state and listeners. Need to figure out the most
;; clojure way of dealing with them.
;;
;; Options:
;;  * Use a dedicated library (may be an overkill)
;;  * Use a set of fx events and keep track of registered listeners

(def worker (js/Worker. "/js/dist/metadata-worker.js"))

(.. worker (addEventListener
            "message"
            (fn [e]
              (let [type (js-interop/get-in e [:data :type])]
                (case type
                  "generate-tree-view"
                  ;; TODO figure out if precomputed metadata tree is even needed anymore
                  (dispatch [:localforage.events/get "db-tree"
                             (fn [_ data]
                               (dispatch [:sql-metadata/update
                                          (->sql-metadata {:tree data
                                                           :processed true})
                                          {:keep-nils true}]))])

                  "generate-completions"
                  (dispatch [:sql-metadata/update
                             (->sql-metadata {:completions {}})
                             {:keep-nils true}])

                  nil)))))


(reg-event-fx
  :sql-console.events/store-completions
  (fn [_ [resp]]
    (let [has-metadata? (some? @(re-posh/subscribe [:sql-metadata/pull]))]

      (dispatch [:localforage.events/store "db-metadata" resp
                 (fn []
                   (.. worker (postMessage #js {:type "generate-tree-view"}))
                   (.. worker (postMessage #js {:type "generate-completions"})))])

      (if has-metadata?
        {:dispatch [:sql-metadata/update (->sql-metadata {:loaded true
                                                          :processed false})
                    {:replace true
                     :keep-nils true}]}
        {:dispatch [:sql-metadata/add (->sql-metadata {:loaded true
                                                       :processed false})
                    {:keep-nils true}]}))))


(reg-event-fx
 :sql-console.events/reset-favourites
 (fn []
   {:dispatch-n [[:sql-query-favourites/add {:sql-query-favourites/items-per-page 100 :sql-query-favourites/page 1}]
                 [:sql-console.api/fetch-favourites {:page      nil
                                                     :order-by  "created_at"
                                                     :order-dir "desc"
                                                     :replace?  true}]]}))

(reg-event-fx
 :sql-console.events/reset-history
 (fn []
   {:dispatch-n [[:sql-query-history/add {:sql-query-history/items-per-page 100 :sql-query-history/page 1}]
                 [:sql-console.api/fetch-history {:page      nil
                                                  :order-by  "created_at"
                                                  :order-dir "desc"
                                                  :replace?  true}]]}))


(reg-event-fx
 :sql-console.events/set-selection
 (fn [_ [selection]]
   {:dispatch [:sql-editor/update (->sql-editor {:selection selection})]}))


(reg-event-fx
 :sql-console.events/set-editor-content
 (fn [_ [code]]
   (let [current-tab  @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab])
         tab-data     @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         new-ts       (.toISOString (js/Date.))

         new-tab-data (into []
                            (-> tab-data
                                (assoc-in [current-tab :code] code)
                                (assoc-in [current-tab :metadata :touched-at] new-ts)))]

     {:dispatch [:sql-editor/update (->sql-editor {:tab-data-container new-tab-data})]})))


(reg-event-fx
 :sql-console.events/create-new-tab
 (fn [_ _]
   (let [new-data {:code                ""
                   :data                []
                   :metadata            {:name      "New statement"
                                         :tab-id    (str (random-uuid))
                                         :opened-at (.toISOString (js/Date.))}
                   :results-tab         0
                   :results-tab-configs {}}
         tab-data     @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         new-tab-data (into tab-data [new-data])]

     {:dispatch-n
      [[:sql-editor/update (->sql-editor {:tab-data-container new-tab-data
                                          :tab-count          (count new-tab-data)})]
       [:sql-console.events/set-editor-content (:code new-data)]]})))


(reg-event-fx
 :sql-console.events/delete-tab
 (fn [_ [remove-idx]]
   (let [current-tab @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab])
         tab-data    @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         new-tab-data  (app.utils/remove-at-index tab-data remove-idx)

         need-to-update-data? (= remove-idx current-tab)

         new-idx       (if need-to-update-data?
                         ;; When removing 0th tab keep tab index at 0
                         (if (= 0 remove-idx)
                           0
                           ;; But when current tab is non-zero, move focus to
                           ;; previous tab
                           (dec current-tab))
                         current-tab)

         new-data      (nth new-tab-data new-idx
                        {:code                ""
                         :data                []
                         :results-tab         0
                         :results-tab-configs {}})]
     {:dispatch-n
      [[:sql-editor/update (->sql-editor (merge
                                          (if need-to-update-data?
                                            new-data
                                            {})
                                          {:tab-data-container new-tab-data
                                           :current-tab new-idx
                                           :tab-count (count new-tab-data)}))]
       (when need-to-update-data?
         [:sql-console.events/set-editor-content (:code new-data)])]})))

(reg-event-fx
 :sql-console.events/reset-tab
 (fn [_ [reset-idx]]
   (let [current-tab @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab])
         tab-data    @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         need-to-update-data? (= reset-idx current-tab)

         new-data    {:code                ""
                      :data                []
                      :results-tab         0
                      :results-tab-configs {}
                      :metadata            {:name      "New statement"
                                            :tab-id    (str (random-uuid))
                                            :opened-at (.toISOString (js/Date.))}}
         new-tab-data (assoc tab-data reset-idx new-data)]
     {:dispatch-n
      [[:sql-editor/update (->sql-editor (merge
                                          (if need-to-update-data?
                                            new-data
                                            {})
                                          {:tab-data-container new-tab-data
                                           :tab-count (count new-tab-data)}))]
       (when need-to-update-data?
         [:sql-console.events/set-editor-content (:code new-data)])]})))


(reg-event-fx
 :sql-console.events/save-tabs-to-local-storage
 (fn [_ _]
   (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         tabs-key @(re-posh/subscribe [:sql-console.misc/tabs-local-storage-key])

         codes    (mapv :code tab-data)]
     {:set-local-storage [tabs-key codes]
      :dispatch [:sql-console.events/save-metadata-to-local-storage]})))


(reg-event-fx
 :sql-console.events/save-metadata-to-local-storage
 (fn [_ _]
   (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         metadata-key @(re-posh/subscribe [:sql-console.misc/tab-metadata-local-storage-key])

         metadata    (mapv :metadata tab-data)]
     {:set-local-storage [metadata-key metadata]})))



(reg-event-fx
 :sql-console.events/save-config-to-local-storage
 (fn [_ _]
   (let [sidebar-width @(re-posh/subscribe [:sql-editor/prop :sql-editor/sidebar-width])
         data-height   @(re-posh/subscribe [:sql-editor/prop :sql-editor/data-preview-height])
         editor-height @(re-posh/subscribe [:sql-editor/prop :sql-editor/editor-height])
         sidebar-tab   @(re-posh/subscribe [:sql-editor/prop :sql-editor/sidebar-tab])
         config-key    @(re-posh/subscribe [:sql-console.misc/config-local-storage-key])]
     {:set-local-storage [config-key {:sidebar-width       sidebar-width
                                      :data-preview-height data-height
                                      :editor-height       editor-height
                                      :sidebar-tab         sidebar-tab}]})))


(reg-event-fx
 :sql-console.events/save-new-transform-template
 (fn [_ [template]]
   {:set-local-storage ["new-transform-template-code" template]}))

(reg-event-fx
 :sql-console.events/refetch-metadata-partial
 (fn [_ [{:keys [fetch-nested]}]]
   (let [metadata @(re-posh/subscribe [:sql-metadata-partial/pull-many])]
     {:dispatch-n (-> (mapv #(vector :sql-metadata-partial/delete (:db/id %))
                            metadata)
                      (conj [:sql-console.api/fetch-metadata
                             {:object "catalogs"}
                             {:on-success (fn []
                                            (mapv #(dispatch [:sql-console.api/fetch-metadata %])
                                                  fetch-nested))}]))})))

(reg-event-db
 :sql-console.events/set-tab-data
 (fn [db [tab-id data]]
   (assoc-in db [:sql-console/data tab-id] data)))
